import { useState } from 'react';
import moment from 'moment';
import { useInterval } from './useInterval';
const format = (lastSeen, extended) => {
    if (!lastSeen)
        return '';
    const duration = moment.duration(moment.utc().diff(moment.utc(lastSeen), 'seconds'), 'seconds');
    const minutes = duration.minutes();
    const hours = duration.hours();
    const days = duration.days();
    const weeks = duration.weeks();
    if (weeks)
        return '';
    if (extended)
        return days
            ? `Active ${days}d ago`
            : hours
                ? `Active ${hours}h ago`
                : minutes
                    ? `Active ${minutes}m ago`
                    : `Active recently`;
    return days
        ? `${days}d`
        : hours
            ? `${hours}h`
            : minutes
                ? `${minutes}m`
                : '1m';
};
export const useLastSeen = (lastSeen, extended) => {
    const [value, setValue] = useState(format(lastSeen, extended));
    useInterval(() => {
        setValue(format(lastSeen, extended));
    }, lastSeen ? 60 * 1000 : null);
    return value;
};
//# sourceMappingURL=useLastSeen.js.map